/**
 * Calendar dates (YYYY-MM-DD) must not use Date#toISOString() for keys — it uses UTC
 * and mismatches DatePicker local dates vs Supabase DATE strings.
 */

/** Parse a YYYY-MM-DD string as a local calendar date (midnight local). */
export function parseDateOnlyLocal(s: string): Date {
  const parts = s.split('-').map(Number);
  const y = parts[0];
  const m = parts[1];
  const d = parts[2];
  if (y == null || m == null || d == null || Number.isNaN(y) || Number.isNaN(m) || Number.isNaN(d)) {
    return new Date(NaN);
  }
  return new Date(y, m - 1, d);
}

/** Format a Date as YYYY-MM-DD in local timezone (for comparing with Supabase DATE strings). */
export function formatLocalYYYYMMDD(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
